import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const BdTongTrmsStatDataTransferRateNew = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    const [searchParams, setSearchParams] = useState({
        searchEmog: '',
        searchGrdc: '',
        searchLoca: '',
        searchYear: '',
    });
    const [emogList, setEmogList] = useState([]);
    const [desc, setDesc] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const fetchHospList = async () => {
        try {
            const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                params: {
                    grdc: searchParams.searchGrdc,
                    loca: searchParams.searchLoca
                }
            });
            setEmogList(response.data.emogList || []);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        fetchHospList();
    }, []);

    useEffect(() => {
        const desc = emogList.find((a) => a.emogcode === searchParams.searchEmog)?.emogdesc;
        setDesc(desc);
    }, [searchParams.searchEmog]);

    const dataHead = ['기관명', '년도', '구분', '전체', '1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
    const dataColumn = ['EMOGDESC', 'YYYY', 'DIV', 'TOTAL_INMM', 'INMM01', 'INMM02', 'INMM03', 'INMM04', 'INMM05', 'INMM06', 'INMM07', 'INMM08', 'INMM09', 'INMM10', 'INMM11', 'INMM12'];
    const apiCall = '/trmsapi/monitoring/bdtongtrms_stat_data_transfer_rate_search_new.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_데이터 전송률 V2-V3`;
    const excelHead = [];
    const mergeConfig = [{ key: 'EMOGDESC', row: null }, { key: 'YYYY', row: 3 }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['15%'],
        wrapTF: true,
    };

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    });

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const searchParamsAdditional = {};

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>내원연도</th>
                            <td>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>기관명</th>
                            <td>
                                <select
                                    name='searchEmog'
                                    className='w-full'
                                    value={searchParams.searchEmog}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    {emogList.map(hosp => (
                                        <option key={hosp.emogcode} value={hosp.emogcode}>
                                            {hosp.emogdesc}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <p>* 2016년 9월부터 Ver. 2.0  및 2020년 1월부터 Ver. 3.0 적용</p>
            <p>* 매일 오전 4시 업데이트</p>
            <p>* 항목 설명</p>
            <p className='ml-2'>- 대상 건수 : 입력대상 + 입력중 + 입력완료 + 외상환자 제외 + 외상 삭제</p>
            <p className='ml-2'>- 입력 건수 : 입력완료 + 입력중 + 외상환자 제외 + 외상 삭제</p>
            <p className='ml-2'>- 전송률 : (입력 건수 / 대상 건수) × 100</p>
            <p>* ‘외상환자 제외’ 및 ‘외상 삭제’인 경우라도 ‘연동 후 제외’인 건 제외</p>
            <p>* 외상등록체계 전송 대상에 한하여 조회</p>
        </Main>
    )
}

export default BdTongTrmsStatDataTransferRateNew;